import { Autocomplete, Grid, Paper, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function ListFilter({
  leaveRequestTypeList,
  leaveRequestType,
  setLeaveRequestType,
  academicYear,
  setAcademicYear,
  selectedTeacher,
  academicYearsProvider,
}) {
  const { t } = useTranslation()

  return (
    <Paper elevation={0} sx={{ width: '100%', py: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Autocomplete
            disabled={!selectedTeacher}
            size="small"
            options={academicYearsProvider ?? []}
            getOptionLabel={option => option.name ?? ''}
            value={academicYearsProvider?.find(item => item.id === academicYear) ?? null}
            onChange={(_, value) => setAcademicYear(value?.id ?? null)}
            renderInput={params => <TextField {...params} label={t('Academic Year')} />}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Autocomplete
            disabled={!selectedTeacher}
            size="small"
            options={leaveRequestTypeList ?? []}
            getOptionLabel={option => option.name ?? ''}
            value={leaveRequestTypeList?.find(item => item.id === leaveRequestType) ?? null}
            onChange={(_, value) => setLeaveRequestType(value?.id ?? null)}
            renderInput={params => <TextField {...params} label={t('Leave Type')} />}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
